import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {dkpStandingsSelector, eventSelector, userSelector} from '../redux/selectors'
import { toArray } from '../common/util';
import {fetchActiveEvents, fetchSectionStandings} from '../redux/actions';
import DataTable from 'react-data-table-component';

const adtTheme = {
    header :{
        fontSize: 'inherit',
        fontColorActive: 'inherit',
        fontColor: 'inherit',
        backgroundColor: 'transparent',
    },
    rows: {
        fontColor: 'inherit',
        backgroundColor: 'transparent',
    },
    cells: {
        cellPadding: '0'
    }
};

const columns = [
    {
        name: 'Name',
        selector: 'user',
        cell: row => row.user && <Link to={"/dkp/standings/"+row.user.slug+"/"+row.sectionSlug}><h5>{row.user.displayName}</h5></Link>
    },
    {
        name: 'Items Purchased',
        selector: 'items',
        sortable: true,
    },
    {
        name: 'Bosses Killed',
        selector: 'entities',
        sortable: true,
    },
    {
        name: 'Attended',
        selector: 'attended',
        sortable: true,
    },
    {
        name: 'Attendance 30-day ',
        selector: 'attendedMonth',
        sortable: true,
        cell: row => row.attendedMonth + "%"
    },
    {
        name: 'Attendance Overall',
        selector: 'attendedOverall',
        sortable: true,
        cell: row => row.attendedOverall + "%"
    },
    {
        name: 'Current DKP',
        selector: 'dkp',
        sortable:true,
        cell: row => <span className="text-primary">{parseFloat(row.dkp).toFixed(2)}</span>
    },
];

class DKPStanding extends Component {
    componentDidMount() {
        this.props.getStanding(this.props.section.chapter, this.props.section.slug);
        this.props.getActiveEvents(this.props.section.chapter, this.props.section.slug)
    }

    render() {
        let data = null;
        if (toArray(this.props.standings).filter((standing) => standing.section === this.props.section.id).length > 0) {

            data = toArray(this.props.standings)
                .filter((standing) => standing.section === this.props.section.id)
                .map(standing => { return {
                    ...standing,
                    user: this.props.users[standing.user],
                    sectionSlug: this.props.section.slug,
                }})
                .sort((a, b) => b.dkp - a.dkp);
        }

        if (data != null) {
            return (
                <div>
                    <div className="panel-adt">
                        <h2>{this.props.section.title} Standings</h2>
                        <DataTable
                            columns={columns}
                            data={data}
                            customTheme={adtTheme}
                            dense
                            noHeader
                        />
                    </div>
                </div>
            )
        } else {
            return (
                <div className="panel-adt">
                    { this.props.dkp.pending ? (<span>Loading...</span>) : (<span>No Data</span>) }
                </div>
            )
        }
    }
}

const mapStateToProps = (state) => ({
    standings: dkpStandingsSelector(state),
    users: userSelector(state),
    events: eventSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getStanding: (chapter, section, page) => dispatch(fetchSectionStandings(chapter, section, page)),
    getActiveEvents: (chapter, section) => dispatch(fetchActiveEvents(chapter, section)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DKPStanding);


// WEBPACK FOOTER //
// ./src/DKP/DKPStanding.js